import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {List} from 'immutable';

class FlexGrid extends Component {
  render () {
    const {wrapperClassName, loading, items, btnLabel, btnLink} = this.props;
    const CardItem = this.props.tileItemClass;

    const itemList = items.toArray().map(item => <CardItem key={item.getId()} data={item} />);

    return (
      <div className={'flex-grid-section ' + (wrapperClassName || '')}>
        <h3 className='flex-grid-section__title'>{ this.props.title }</h3>

        <div className={'flex-grid-section__content' + (loading ? ' loading' : '')}>
          {
            loading
              ? (
                <div className='ajax-waiting-overlay'>
                  <div className='radial-progress'>
                    <div className='circle'>
                      <div className='fill' />
                    </div>
                  </div>
                </div>
              )
              : itemList
          }
        </div>

        {
          btnLink && btnLabel && (
            <div className='footer'>
              <a className='btn-base btn-hollow' href={btnLink}>{btnLabel}</a>
            </div>
          )
        }
      </div>
    );
  }
}

FlexGrid.propTypes = {
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  items: PropTypes.object,
  tileItemClass: PropTypes.func.isRequired,
  wrapperClassName: PropTypes.string,

  btnLabel: PropTypes.string,
  btnLink: PropTypes.string
};

FlexGrid.defaultProps = {
  wrapperClassName: null,
  loading: false,
  items: new List(),
  btnLabel: null,
  btnLink: null
};

export default FlexGrid;



// WEBPACK FOOTER //
// ./src/ui/Widgets/FlexGrid.jsx